import rangeMap from '@/lib/range-map';
import ContentLoader from 'react-content-loader';

const SearchItemLoader = () => {
    return (
        <div className="flex flex-col gap-1">
            {rangeMap(2, item => (
                <ContentLoader
                    speed={2}
                    width={'100%'}
                    height={140}
                    backgroundColor="#f3f3f3"
                    foregroundColor="#ecebeb"
                    key={item}>
                    <rect x="0" y="0" rx="3" ry="3" width="120" height="120" />

                    <rect x="130" y="0" rx="3" ry="3" width="90%" height="20" />

                    <rect x="130" y="35" rx="3" ry="3" width="40%" height="15" />

                    <rect x="130" y="60" rx="3" ry="3" width="40%" height="15" />
                </ContentLoader>
            ))}
        </div>
    );
};

export default SearchItemLoader;
